import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgHelpdeskDomain = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32.7484 11.2985C29.9695 14.1875 28.8636 13.6538 25.4353 10.2311L12.2661 21.6285C15.1268 24.6516 14.3559 28.0204 12.9722 29.1282L33.2019 54.3962C37.1884 51.2046 39.5362 53.8793 40.6603 55.5412L53.1949 45.5058C50.1651 41.859 52.5762 38.4422 53.9523 37.7832L32.7484 11.2985Z",
			fill: "#FFD000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.8007 10.7028C28.2006 13.585 26.2176 13.176 22.8403 8.95755L10.7336 18.6503C13.5943 21.6735 14.0303 24.9299 11.0503 27.3157C11.0503 27.3157 16.154 34.2527 20.5404 39.1692C24.9267 44.0858 30.7838 51.9638 30.7838 51.9638C34.7703 48.7722 37.0947 51.2007 38.9702 53.5432L51.2731 43.6933C47.8011 39.3567 49.1265 37.2785 51.5342 35.3509L31.8007 10.7028Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.8821 31.7982C38.5009 32.1272 35.9522 33.6301 33.6785 35.3216C31.9708 36.592 30.6118 38.0023 29.3713 38.9171",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.9797 37.4138C40.6573 37.6921 36.9075 40.2962 35.3639 41.7332",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.2083 20.6105L31.6846 21.7677",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.6179 24.8207L26.1151 25.9463",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.0847 29.2347L20.1721 30.5122",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgHelpdeskDomain;
